export function compareAddresses(addressA?: string, addressB?: string): boolean {
  if (!addressA || !addressB) {
    return false;
  }

  return addressA.toLowerCase() === addressB.toLowerCase();
}
